import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { EditColumnsIcon } from 'foundations-assets';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { MediaLeft } from 'foundations-components/transitional/components/MediaLeft';
import { FilterBar } from 'foundations-components/transitional/components/FilterBar';
import VariationsTableColumnSwitcherModal from './AsyncVariationsTableColumnSwitcherModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const VariationsTableFilterBar = ({
  metricsToDisplay,
  onColumnChange
}) => {
  const [isColumnSwitcherOpen, setIsColumnSwitcherOpen] = useState(false);
  return /*#__PURE__*/_jsx(FilterBar, {
    endSlot: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: () => setIsColumnSwitcherOpen(true),
        use: "link",
        children: /*#__PURE__*/_jsxs(Media, {
          spacing: "none",
          children: [/*#__PURE__*/_jsx(MediaLeft, {
            children: /*#__PURE__*/_jsx(EditColumnsIcon, {
              size: "300"
            })
          }), /*#__PURE__*/_jsx(MediaBody, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "page-details-ui.testResults.variationsTableFilterBar.columnSwitcher.button"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(VariationsTableColumnSwitcherModal, {
        isColumnSwitcherOpen: isColumnSwitcherOpen,
        closeModal: () => setIsColumnSwitcherOpen(false),
        metricsToDisplay: metricsToDisplay,
        onColumnChange: onColumnChange
      })]
    })
  });
};
export default VariationsTableFilterBar;